declare namespace $ {

	type $mol_labeler__title_bog_gamengine_demo_legion_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_gamengine_demo_legion_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_bog_gamengine_demo_legion_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_gamengine_demo_legion_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_labeler__title_bog_gamengine_demo_legion_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_gamengine_demo_legion_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_check_box__title_bog_gamengine_demo_legion_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_gamengine_demo_legion_8 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['paused'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $bog_gamengine_draw__scene_bog_gamengine_demo_legion_9 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Scene'] >
		,
		ReturnType< $bog_gamengine_draw['scene'] >
	>
	type $bog_gamengine_draw__cam_bog_gamengine_demo_legion_10 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Cam'] >
		,
		ReturnType< $bog_gamengine_draw['cam'] >
	>
	type $bog_gamengine_draw__event_bog_gamengine_demo_legion_11 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_gamengine_demo_legion['pointer_down'] > ): ReturnType< $bog_gamengine_demo_legion['pointer_down'] >,
			pointermove( next?: ReturnType< $bog_gamengine_demo_legion['pointer_move'] > ): ReturnType< $bog_gamengine_demo_legion['pointer_move'] >,
			pointerup( next?: ReturnType< $bog_gamengine_demo_legion['pointer_up'] > ): ReturnType< $bog_gamengine_demo_legion['pointer_up'] >,
			pointerleave( next?: ReturnType< $bog_gamengine_demo_legion['pointer_leave'] > ): ReturnType< $bog_gamengine_demo_legion['pointer_leave'] >,
			wheel( next?: ReturnType< $bog_gamengine_demo_legion['wheel'] > ): ReturnType< $bog_gamengine_demo_legion['wheel'] >,
			contextmenu( next?: ReturnType< $bog_gamengine_demo_legion['menu'] > ): ReturnType< $bog_gamengine_demo_legion['menu'] >,
		}) 
		,
		ReturnType< $bog_gamengine_draw['event'] >
	>
	type $mol_view__style_bog_gamengine_demo_legion_12 = $mol_type_enforce<
		({ 
			'left': ReturnType< $bog_gamengine_demo_legion['band_left'] >,
			'top': ReturnType< $bog_gamengine_demo_legion['band_top'] >,
			'width': ReturnType< $bog_gamengine_demo_legion['band_width'] >,
			'height': ReturnType< $bog_gamengine_demo_legion['band_height'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_bog_gamengine_demo_legion_13 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['dots'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gamengine_demo_legion_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__title_bog_gamengine_demo_legion_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_bog_gamengine_demo_legion_16 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['restart'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_page__title_bog_gamengine_demo_legion_17 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['end_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_bog_gamengine_demo_legion_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__foot_bog_gamengine_demo_legion_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['foot'] >
	>
	type $mol_view__sub_bog_gamengine_demo_legion_20 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['field'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gamengine_demo_legion_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gamengine_demo_legion_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type __bog_gamengine_demo_legion_23 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_legion['mine_dead'] >[0]
		,
		Parameters< $bog_gamengine_demo_legion['Mine'] >[0]
	>
	type __bog_gamengine_demo_legion_24 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_legion['mine_dead'] >[1]
		,
		Parameters< $bog_gamengine_demo_legion['Mine'] >[0]
	>
	type __bog_gamengine_demo_legion_25 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_legion['foe_dead'] >[0]
		,
		Parameters< $bog_gamengine_demo_legion['Foe'] >[0]
	>
	type __bog_gamengine_demo_legion_26 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_legion['foe_dead'] >[1]
		,
		Parameters< $bog_gamengine_demo_legion['Foe'] >[0]
	>
	type $mol_view__style_bog_gamengine_demo_legion_27 = $mol_type_enforce<
		({ 
			'left': ReturnType< $bog_gamengine_demo_legion['dot_left'] >,
			'top': ReturnType< $bog_gamengine_demo_legion['dot_top'] >,
			'background': ReturnType< $bog_gamengine_demo_legion['dot_back'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $bog_gamengine_phys_tile__map_bog_gamengine_demo_legion_28 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['map'] >
		,
		ReturnType< $bog_gamengine_phys_tile['map'] >
	>
	type $bog_gamengine_phys_tile__solid_bog_gamengine_demo_legion_29 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_phys_tile['solid'] >
	>
	type $bog_gamengine_nav_grid__tile_bog_gamengine_demo_legion_30 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Tile'] >
		,
		ReturnType< $bog_gamengine_nav_grid['tile'] >
	>
	type $bog_gamengine_nav_grid__pad_bog_gamengine_demo_legion_31 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_nav_grid['pad'] >
	>
	type $bog_gamengine_atlas__uris_bog_gamengine_demo_legion_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_gamengine_atlas['uris'] >
	>
	type $bog_gamengine_atlas__size_bog_gamengine_demo_legion_33 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_atlas['size'] >
	>
	type $bog_gamengine_sound__listener_bog_gamengine_demo_legion_34 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Cam'] >
		,
		ReturnType< $bog_gamengine_sound['listener'] >
	>
	type $bog_gamengine_sound__range_bog_gamengine_demo_legion_35 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_sound['range'] >
	>
	type $bog_gamengine_sound__uris_bog_gamengine_demo_legion_36 = $mol_type_enforce<
		({ 
			'hit': string,
			'order': string,
		}) 
		,
		ReturnType< $bog_gamengine_sound['uris'] >
	>
	type $bog_gamengine_point__cam_bog_gamengine_demo_legion_37 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Cam'] >
		,
		ReturnType< $bog_gamengine_point['cam'] >
	>
	type $bog_gamengine_point__width_bog_gamengine_demo_legion_38 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['draw_width'] >
		,
		ReturnType< $bog_gamengine_point['width'] >
	>
	type $bog_gamengine_point__height_bog_gamengine_demo_legion_39 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['draw_height'] >
		,
		ReturnType< $bog_gamengine_point['height'] >
	>
	type $bog_gamengine_point__scale_bog_gamengine_demo_legion_40 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['draw_dpr'] >
		,
		ReturnType< $bog_gamengine_point['scale'] >
	>
	type $bog_gamengine_scene__clock_bog_gamengine_demo_legion_41 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Clock'] >
		,
		ReturnType< $bog_gamengine_scene['clock'] >
	>
	type $bog_gamengine_scene__cam_bog_gamengine_demo_legion_42 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Cam'] >
		,
		ReturnType< $bog_gamengine_scene['cam'] >
	>
	type $bog_gamengine_scene__kids_bog_gamengine_demo_legion_43 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['nodes'] >
		,
		ReturnType< $bog_gamengine_scene['kids'] >
	>
	type $bog_gamengine_scene__batches_bog_gamengine_demo_legion_44 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['batches'] >
		,
		ReturnType< $bog_gamengine_scene['batches'] >
	>
	type $bog_gamengine_cam_flat__height_bog_gamengine_demo_legion_45 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_cam_flat['height'] >
	>
	type $bog_gamengine_cam_flat__zoom_bog_gamengine_demo_legion_46 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['cam_zoom'] >
		,
		ReturnType< $bog_gamengine_cam_flat['zoom'] >
	>
	type $bog_gamengine_cam_flat__zoom_min_bog_gamengine_demo_legion_47 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_cam_flat['zoom_min'] >
	>
	type $bog_gamengine_cam_flat__zoom_max_bog_gamengine_demo_legion_48 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_cam_flat['zoom_max'] >
	>
	type $bog_gamengine_cam_flat__pos_bog_gamengine_demo_legion_49 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['cam_pos'] >
		,
		ReturnType< $bog_gamengine_cam_flat['pos'] >
	>
	type $bog_gamengine_cam_flat__bounds_bog_gamengine_demo_legion_50 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['cam_bounds'] >
		,
		ReturnType< $bog_gamengine_cam_flat['bounds'] >
	>
	type $bog_gamengine_cam_edge__cam_bog_gamengine_demo_legion_51 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Cam'] >
		,
		ReturnType< $bog_gamengine_cam_edge['cam'] >
	>
	type $bog_gamengine_cam_edge__width_bog_gamengine_demo_legion_52 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['draw_width'] >
		,
		ReturnType< $bog_gamengine_cam_edge['width'] >
	>
	type $bog_gamengine_cam_edge__height_bog_gamengine_demo_legion_53 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['draw_height'] >
		,
		ReturnType< $bog_gamengine_cam_edge['height'] >
	>
	type $bog_gamengine_cam_edge__speed_bog_gamengine_demo_legion_54 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_cam_edge['speed'] >
	>
	type $bog_gamengine_tilemap__tile_bog_gamengine_demo_legion_55 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Tile'] >
		,
		ReturnType< $bog_gamengine_tilemap['tile'] >
	>
	type $bog_gamengine_tilemap__atlas_bog_gamengine_demo_legion_56 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Atlas'] >
		,
		ReturnType< $bog_gamengine_tilemap['atlas'] >
	>
	type $bog_gamengine_tilemap__palette_bog_gamengine_demo_legion_57 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['palette'] >
		,
		ReturnType< $bog_gamengine_tilemap['palette'] >
	>
	type $bog_gamengine_batch__shader_bog_gamengine_demo_legion_58 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Sprite_shader'] >
		,
		ReturnType< $bog_gamengine_batch['shader'] >
	>
	type $bog_gamengine_batch__atlas_bog_gamengine_demo_legion_59 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Atlas'] >
		,
		ReturnType< $bog_gamengine_batch['atlas'] >
	>
	type $bog_gamengine_batch__source_bog_gamengine_demo_legion_60 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['tilemap_pool'] >
		,
		ReturnType< $bog_gamengine_batch['source'] >
	>
	type $bog_gamengine_particle__atlas_bog_gamengine_demo_legion_61 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Atlas'] >
		,
		ReturnType< $bog_gamengine_particle['atlas'] >
	>
	type $bog_gamengine_particle__frame_bog_gamengine_demo_legion_62 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_particle['frame'] >
	>
	type $bog_gamengine_particle__rate_bog_gamengine_demo_legion_63 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_particle['rate'] >
	>
	type $bog_gamengine_particle__life_bog_gamengine_demo_legion_64 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['flash_life'] >
		,
		ReturnType< $bog_gamengine_particle['life'] >
	>
	type $bog_gamengine_particle__speed_bog_gamengine_demo_legion_65 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['flash_speed'] >
		,
		ReturnType< $bog_gamengine_particle['speed'] >
	>
	type $bog_gamengine_particle__spread_bog_gamengine_demo_legion_66 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_particle['spread'] >
	>
	type $bog_gamengine_particle__size_bog_gamengine_demo_legion_67 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['flash_size'] >
		,
		ReturnType< $bog_gamengine_particle['size'] >
	>
	type $bog_gamengine_particle__color_bog_gamengine_demo_legion_68 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['flash_color'] >
		,
		ReturnType< $bog_gamengine_particle['color'] >
	>
	type $bog_gamengine_batch__shader_bog_gamengine_demo_legion_69 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Sprite_shader'] >
		,
		ReturnType< $bog_gamengine_batch['shader'] >
	>
	type $bog_gamengine_batch__atlas_bog_gamengine_demo_legion_70 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Atlas'] >
		,
		ReturnType< $bog_gamengine_batch['atlas'] >
	>
	type $bog_gamengine_batch__source_bog_gamengine_demo_legion_71 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['flash_pool'] >
		,
		ReturnType< $bog_gamengine_batch['source'] >
	>
	type $bog_gamengine_sprite__atlas_bog_gamengine_demo_legion_72 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Atlas'] >
		,
		ReturnType< $bog_gamengine_sprite['atlas'] >
	>
	type $bog_gamengine_sprite__frame_bog_gamengine_demo_legion_73 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['frame'] >
	>
	type $bog_gamengine_sprite__pos_bog_gamengine_demo_legion_74 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['res_pos'] >
		,
		ReturnType< $bog_gamengine_sprite['pos'] >
	>
	type $bog_gamengine_sprite__size_bog_gamengine_demo_legion_75 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['res_size'] >
		,
		ReturnType< $bog_gamengine_sprite['size'] >
	>
	type $bog_gamengine_demo_legion_unit__camp_bog_gamengine_demo_legion_76 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_demo_legion_unit['camp'] >
	>
	type $bog_gamengine_demo_legion_unit__grid_bog_gamengine_demo_legion_77 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Grid'] >
		,
		ReturnType< $bog_gamengine_demo_legion_unit['grid'] >
	>
	type $bog_gamengine_demo_legion_unit__sound_bog_gamengine_demo_legion_78 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Sound'] >
		,
		ReturnType< $bog_gamengine_demo_legion_unit['sound'] >
	>
	type $bog_gamengine_demo_legion_unit__flash_bog_gamengine_demo_legion_79 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Flash'] >
		,
		ReturnType< $bog_gamengine_demo_legion_unit['flash'] >
	>
	type $bog_gamengine_demo_legion_unit__others_bog_gamengine_demo_legion_80 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['mine_alive'] >
		,
		ReturnType< $bog_gamengine_demo_legion_unit['others'] >
	>
	type $bog_gamengine_demo_legion_unit__foes_bog_gamengine_demo_legion_81 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['foe_alive'] >
		,
		ReturnType< $bog_gamengine_demo_legion_unit['foes'] >
	>
	type $bog_gamengine_demo_legion_unit__brain_bog_gamengine_demo_legion_82 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Brain'] >
		,
		ReturnType< $bog_gamengine_demo_legion_unit['brain'] >
	>
	type $bog_gamengine_demo_legion_unit__fight_bog_gamengine_demo_legion_83 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Mine_fight'] >
		,
		ReturnType< $bog_gamengine_demo_legion_unit['fight'] >
	>
	type $bog_gamengine_demo_legion_unit__kids_bog_gamengine_demo_legion_84 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['mine_kids'] >
		,
		ReturnType< $bog_gamengine_demo_legion_unit['kids'] >
	>
	type $bog_gamengine_demo_legion_unit__speed_bog_gamengine_demo_legion_85 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_demo_legion_unit['speed'] >
	>
	type $bog_gamengine_demo_legion_unit__pos_bog_gamengine_demo_legion_86 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['mine_pos'] >
		,
		ReturnType< $bog_gamengine_demo_legion_unit['pos'] >
	>
	type $bog_gamengine_sprite__parent_bog_gamengine_demo_legion_87 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Mine'] >
		,
		ReturnType< $bog_gamengine_sprite['parent'] >
	>
	type $bog_gamengine_sprite__atlas_bog_gamengine_demo_legion_88 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Atlas'] >
		,
		ReturnType< $bog_gamengine_sprite['atlas'] >
	>
	type $bog_gamengine_sprite__frame_bog_gamengine_demo_legion_89 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['frame'] >
	>
	type $bog_gamengine_sprite__size_bog_gamengine_demo_legion_90 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['unit_size'] >
		,
		ReturnType< $bog_gamengine_sprite['size'] >
	>
	type $bog_gamengine_sprite__tint_bog_gamengine_demo_legion_91 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['mine_tint'] >
		,
		ReturnType< $bog_gamengine_sprite['tint'] >
	>
	type $bog_gamengine_combat__owner_bog_gamengine_demo_legion_92 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Mine'] >
		,
		ReturnType< $bog_gamengine_combat['owner'] >
	>
	type $bog_gamengine_combat__health_max_bog_gamengine_demo_legion_93 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_combat['health_max'] >
	>
	type $bog_gamengine_combat__rate_bog_gamengine_demo_legion_94 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_combat['rate'] >
	>
	type $bog_gamengine_brain_fsm__owner_bog_gamengine_demo_legion_95 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Mine'] >
		,
		ReturnType< $bog_gamengine_brain_fsm['owner'] >
	>
	type $bog_gamengine_brain_fsm__kids_bog_gamengine_demo_legion_96 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['brain_kids'] >
		,
		ReturnType< $bog_gamengine_brain_fsm['kids'] >
	>
	type $bog_gamengine_brain_state__name_bog_gamengine_demo_legion_97 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_brain_state['name'] >
	>
	type $bog_gamengine_brain_state__next_bog_gamengine_demo_legion_98 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['idle_next'] >
		,
		ReturnType< $bog_gamengine_brain_state['next'] >
	>
	type $bog_gamengine_brain_state__name_bog_gamengine_demo_legion_99 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_brain_state['name'] >
	>
	type $bog_gamengine_brain_state__next_bog_gamengine_demo_legion_100 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['move_next'] >
		,
		ReturnType< $bog_gamengine_brain_state['next'] >
	>
	type $bog_gamengine_brain_state__name_bog_gamengine_demo_legion_101 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_brain_state['name'] >
	>
	type $bog_gamengine_brain_state__next_bog_gamengine_demo_legion_102 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['attack_next'] >
		,
		ReturnType< $bog_gamengine_brain_state['next'] >
	>
	type $bog_gamengine_brain_state__name_bog_gamengine_demo_legion_103 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_brain_state['name'] >
	>
	type $bog_gamengine_demo_legion_unit__camp_bog_gamengine_demo_legion_104 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_demo_legion_unit['camp'] >
	>
	type $bog_gamengine_demo_legion_unit__grid_bog_gamengine_demo_legion_105 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Grid'] >
		,
		ReturnType< $bog_gamengine_demo_legion_unit['grid'] >
	>
	type $bog_gamengine_demo_legion_unit__sound_bog_gamengine_demo_legion_106 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Sound'] >
		,
		ReturnType< $bog_gamengine_demo_legion_unit['sound'] >
	>
	type $bog_gamengine_demo_legion_unit__flash_bog_gamengine_demo_legion_107 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Flash'] >
		,
		ReturnType< $bog_gamengine_demo_legion_unit['flash'] >
	>
	type $bog_gamengine_demo_legion_unit__others_bog_gamengine_demo_legion_108 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['foe_alive'] >
		,
		ReturnType< $bog_gamengine_demo_legion_unit['others'] >
	>
	type $bog_gamengine_demo_legion_unit__foes_bog_gamengine_demo_legion_109 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['mine_alive'] >
		,
		ReturnType< $bog_gamengine_demo_legion_unit['foes'] >
	>
	type $bog_gamengine_demo_legion_unit__brain_bog_gamengine_demo_legion_110 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Tree'] >
		,
		ReturnType< $bog_gamengine_demo_legion_unit['brain'] >
	>
	type $bog_gamengine_demo_legion_unit__fight_bog_gamengine_demo_legion_111 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Foe_fight'] >
		,
		ReturnType< $bog_gamengine_demo_legion_unit['fight'] >
	>
	type $bog_gamengine_demo_legion_unit__kids_bog_gamengine_demo_legion_112 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['foe_kids'] >
		,
		ReturnType< $bog_gamengine_demo_legion_unit['kids'] >
	>
	type $bog_gamengine_demo_legion_unit__home_bog_gamengine_demo_legion_113 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['foe_home'] >
		,
		ReturnType< $bog_gamengine_demo_legion_unit['home'] >
	>
	type $bog_gamengine_demo_legion_unit__speed_bog_gamengine_demo_legion_114 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_demo_legion_unit['speed'] >
	>
	type $bog_gamengine_demo_legion_unit__pos_bog_gamengine_demo_legion_115 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['foe_pos'] >
		,
		ReturnType< $bog_gamengine_demo_legion_unit['pos'] >
	>
	type $bog_gamengine_sprite__parent_bog_gamengine_demo_legion_116 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Foe'] >
		,
		ReturnType< $bog_gamengine_sprite['parent'] >
	>
	type $bog_gamengine_sprite__atlas_bog_gamengine_demo_legion_117 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Atlas'] >
		,
		ReturnType< $bog_gamengine_sprite['atlas'] >
	>
	type $bog_gamengine_sprite__frame_bog_gamengine_demo_legion_118 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['frame'] >
	>
	type $bog_gamengine_sprite__size_bog_gamengine_demo_legion_119 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['unit_size'] >
		,
		ReturnType< $bog_gamengine_sprite['size'] >
	>
	type $bog_gamengine_combat__owner_bog_gamengine_demo_legion_120 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Foe'] >
		,
		ReturnType< $bog_gamengine_combat['owner'] >
	>
	type $bog_gamengine_combat__health_max_bog_gamengine_demo_legion_121 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_combat['health_max'] >
	>
	type $bog_gamengine_combat__rate_bog_gamengine_demo_legion_122 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_combat['rate'] >
	>
	type $bog_gamengine_brain_bt__owner_bog_gamengine_demo_legion_123 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['Foe'] >
		,
		ReturnType< $bog_gamengine_brain_bt['owner'] >
	>
	type $bog_gamengine_brain_bt__kids_bog_gamengine_demo_legion_124 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['tree_kids'] >
		,
		ReturnType< $bog_gamengine_brain_bt['kids'] >
	>
	type $bog_gamengine_brain_bt_sel__kids_bog_gamengine_demo_legion_125 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['plan_kids'] >
		,
		ReturnType< $bog_gamengine_brain_bt_sel['kids'] >
	>
	type $bog_gamengine_brain_bt_seq__kids_bog_gamengine_demo_legion_126 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['fight_kids'] >
		,
		ReturnType< $bog_gamengine_brain_bt_seq['kids'] >
	>
	type $bog_gamengine_brain_bt_cond__when_bog_gamengine_demo_legion_127 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_brain_bt_cond['when'] >
	>
	type $bog_gamengine_demo_legion_act__mode_bog_gamengine_demo_legion_128 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_demo_legion_act['mode'] >
	>
	type $bog_gamengine_brain_bt_seq__kids_bog_gamengine_demo_legion_129 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_legion['hunt_kids'] >
		,
		ReturnType< $bog_gamengine_brain_bt_seq['kids'] >
	>
	type $bog_gamengine_brain_bt_cond__when_bog_gamengine_demo_legion_130 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_brain_bt_cond['when'] >
	>
	type $bog_gamengine_demo_legion_act__mode_bog_gamengine_demo_legion_131 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_demo_legion_act['mode'] >
	>
	type $bog_gamengine_demo_legion_act__mode_bog_gamengine_demo_legion_132 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_demo_legion_act['mode'] >
	>
	export class $bog_gamengine_demo_legion extends $mol_page {
		mine_count( ): string
		Mine_count( ): $mol_labeler
		foe_count( ): string
		Foe_count( ): $mol_labeler
		sel_count( ): string
		Sel_count( ): $mol_labeler
		paused( next?: boolean ): boolean
		Pause_switch( ): $mol_check_box
		stat( ): ReturnType< ReturnType< $bog_gamengine_demo_legion['Draw'] >['stat'] >
		draw_width( ): ReturnType< ReturnType< $bog_gamengine_demo_legion['Draw'] >['width'] >
		draw_height( ): ReturnType< ReturnType< $bog_gamengine_demo_legion['Draw'] >['height'] >
		draw_dpr( ): ReturnType< ReturnType< $bog_gamengine_demo_legion['Draw'] >['dpr'] >
		pointer_down( next?: any ): any
		pointer_move( next?: any ): any
		pointer_up( next?: any ): any
		pointer_leave( next?: any ): any
		wheel( next?: any ): any
		menu( next?: any ): any
		Draw( ): $bog_gamengine_draw
		band_left( ): string
		band_top( ): string
		band_width( ): string
		band_height( ): string
		Band( ): $mol_view
		dots( ): readonly(any)[]
		Minimap( ): $mol_view
		end_title( ): string
		end_hint( ): string
		End_hint( ): $mol_view
		restart( next?: any ): any
		Again( ): $mol_button_major
		End( ): $mol_page
		field( ): readonly(any)[]
		Field( ): $mol_view
		legion_stat( ): string
		Legion_stat( ): $mol_view
		Stat( ): $mol_view
		dot_left( id: any): string
		dot_top( id: any): string
		dot_back( id: any): string
		nodes( ): readonly(any)[]
		batches( ): readonly(any)[]
		cam_zoom( next?: number ): number
		cam_pos( next?: Float32Array ): Float32Array
		cam_bounds( ): Float32Array
		palette( ): Record<string, any>
		Sprite_shader( ): $bog_gamengine_shader_sprite
		tilemap_pool( ): any
		flash_life( ): Float32Array
		flash_speed( ): Float32Array
		flash_size( ): Float32Array
		flash_color( ): Float32Array
		flash_pool( ): any
		res_pos( id: any): Float32Array
		res_size( ): Float32Array
		mine_alive( ): readonly(any)[]
		foe_alive( ): readonly(any)[]
		mine_kids( id: any): readonly(any)[]
		mine_pos( id: any, next?: Float32Array ): Float32Array
		mine_dead( id: any, next?: ReturnType< ReturnType< $bog_gamengine_demo_legion['Mine'] >['dead'] > ): ReturnType< ReturnType< $bog_gamengine_demo_legion['Mine'] >['dead'] >
		unit_size( ): Float32Array
		mine_tint( id: any): Float32Array
		brain_kids( id: any): readonly(any)[]
		idle_next( ): readonly(any)[]
		move_next( ): readonly(any)[]
		attack_next( ): readonly(any)[]
		foe_kids( id: any): readonly(any)[]
		foe_home( id: any): Float32Array
		foe_pos( id: any, next?: Float32Array ): Float32Array
		foe_dead( id: any, next?: ReturnType< ReturnType< $bog_gamengine_demo_legion['Foe'] >['dead'] > ): ReturnType< ReturnType< $bog_gamengine_demo_legion['Foe'] >['dead'] >
		tree_kids( id: any): readonly(any)[]
		plan_kids( id: any): readonly(any)[]
		fight_kids( id: any): readonly(any)[]
		hunt_kids( id: any): readonly(any)[]
		title( ): string
		key_map( ): Record<string, any>
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
		foot( ): readonly(any)[]
		Dot( id: any): $mol_view
		map( ): string
		Tile( ): $bog_gamengine_phys_tile
		Grid( ): $bog_gamengine_nav_grid
		Atlas( ): $bog_gamengine_atlas
		Sound( ): $bog_gamengine_sound
		Point( ): $bog_gamengine_point
		Clock( ): $bog_gamengine_clock
		Scene( ): $bog_gamengine_scene
		Cam( ): $bog_gamengine_cam_flat
		Edge( ): $bog_gamengine_cam_edge
		Squad( ): $bog_gamengine_nav_squad
		Tilemap( ): $bog_gamengine_tilemap
		Tilemap_batch( ): $bog_gamengine_batch
		Flash( ): $bog_gamengine_particle
		Flash_batch( ): $bog_gamengine_batch
		Res( id: any): $bog_gamengine_sprite
		Mine( id: any): $bog_gamengine_demo_legion_unit
		Mine_sprite( id: any): $bog_gamengine_sprite
		Mine_fight( id: any): $bog_gamengine_combat
		Brain( id: any): $bog_gamengine_brain_fsm
		Idle( id: any): $bog_gamengine_brain_state
		Move( id: any): $bog_gamengine_brain_state
		Attack( id: any): $bog_gamengine_brain_state
		Fallen( id: any): $bog_gamengine_brain_state
		Foe( id: any): $bog_gamengine_demo_legion_unit
		Foe_sprite( id: any): $bog_gamengine_sprite
		Foe_fight( id: any): $bog_gamengine_combat
		Tree( id: any): $bog_gamengine_brain_bt
		Plan( id: any): $bog_gamengine_brain_bt_sel
		Fight( id: any): $bog_gamengine_brain_bt_seq
		Near( id: any): $bog_gamengine_brain_bt_cond
		Strike( id: any): $bog_gamengine_demo_legion_act
		Hunt( id: any): $bog_gamengine_brain_bt_seq
		Seen( id: any): $bog_gamengine_brain_bt_cond
		Rush( id: any): $bog_gamengine_demo_legion_act
		Roam( id: any): $bog_gamengine_demo_legion_act
	}
	
}

//# sourceMappingURL=legion.view.tree.d.ts.map